export const helpCenterRoleIconToolbar = 'HELPCENTER';

export const helpCenterWhatsNewPageId = 'what-s-new';

export const helpCenterAssistantTabPageId = 'equipment-details-pai';

export const helpCenterAssistantHistoryPageId = 'equipment-details-pai-history';

export const helpCenterApplicationTabCategory = 'application';

export const helpCenterAssistantTabCategory = 'assistant';

export const helpCenterApiAssistantTabCategory = 'aiassistant';

export const helpCenterPageIdMap = {
  'site-details/pai/active': {
    pageId: 'site-details-to-do-list',
    enable: true,
    appCode: 'PAI',
  },
  'site-details/ais/active': {
    pageId: 'site-details-site-summary',
    enable: true,
    appCode: 'PAI',
  },
  'equipment-details/pai/details': {
    pageId: 'equipment-details-pai',
    enable: true,
    appCode: 'PAI',
  },
  home: {
    pageId: 'portfolio-summary',
    enable: true,
    appCode: 'PAI',
  },
  favorites: {
    pageId: 'favorites',
    enable: true,
    appCode: 'PAI',
  },
  'trends-view': {
    pageId: 'portfolio-trends',
    enable: true,
    appCode: 'PAI',
  },
  'trends-view/equipment': {
    pageId: 'portfolio-trends-health-summary',
    enable: true,
    appCode: 'PAI',
  },
  'trends-view/opportunity': {
    pageId: 'portfolio-trends-opportunity-summary',
    enable: true,
    appCode: 'PAI',
  },
  'site-list': {
    pageId: 'site-list-list',
    enable: true,
    appCode: 'PAI',
  },
  'site-list?map=yes': {
    pageId: 'site-list-map',
    enable: true,
    appCode: 'PAI',
  },
  'equipment-details/pai/history': {
    pageId: 'equipment-details-pai-history',
    enable: true,
    appCode: 'PAI',
  },
  search: {
    pageId: 'search',
    enable: true,
    appCode: 'PAI',
  },
  about: {
    pageId: 'about-abound-insights',
    enable: true,
    appCode: 'PAI',
  },
  [helpCenterWhatsNewPageId]: {
    pageId: helpCenterWhatsNewPageId,
    enable: true,
    appCode: 'PAI',
  },
  'live-connect': {
    pageId: 'site-details-live-connect-live',
    enable: true,
    appCode: 'Live Connect',
  },
  'temperature-and-consumption': {
    pageId: 'site-details-temperature-and-consumption-view',
    enable: true,
    appCode: 'TC',
  },
};

export const pageTypeStatus = 'active';
